// Api lookup keys & related constants

export const LookupKeyParameterName = 'lookupKey';

export const LookupKeys = {
    // Lookup key constants
    Associations: 'associations',
    AssociationsAddBid: 'associationsaddbid',
    // AssociationsWithClient: 'associationsWithClient',
    AssociationTypes: 'associationTypes',
    TextContents: 'textContents',
    Clients: 'clients',
    Contacts: 'contacts',
    ComponentCategories: 'componentCategories',
    Components: 'components',
    ComponentLocations: 'componentLocations',
    // ClientsWithRegion: 'clientsWithRegion',
    ClientTypes: 'clientTypes',
    Companies: 'companies',
    ElevatorTypes: 'elevatorTypes',
    FencingTypes: 'fencingTypes',
    InteriorHallTypes: 'interiorHallTypes',
    IrrigationTypes: 'irrigationTypes',
    InventoryTemplates: 'inventoryTemplates',
    InventoryTemplatesGroupComponents: 'inventoryTemplatesGroupComponents',
    Groups: 'groups',
    GroupComponentsStandardEvaluations: 'groupComponentsStandardEvaluations',
    MechanicalTypes: 'mechanicalTypes',
    ReplacementCostTypes: 'replacementCostTypes',
    ReplacementCosts: 'replacementCosts',
    RecRoomTypes: 'recRoomTypes',
    Regions: 'regions',
    RoofTypes: 'roofTypes',
    Salutations: 'salutations',
    SecuredTypes: 'securedTypes',
    SidingTypes: 'sidingTypes',
    Statuses: 'statuses',
    StatusLevels: 'statusLevels',
    ServiceLevels: 'serviceLevels',
    StreetTypes: 'streetTypes',
    TempPasswords: 'tempPasswords',
    Users: 'users',
    UserInventoryTemplates: 'userInventoryTemplates',
    UserResumes: 'userResumes',
    UsersManagers: 'usersManagers', // Pseudo - searchActiveJobs
    UsersCoordinators: 'usersCoordinators', // Pseudo - searchActiveJobs
    Roles: 'roles',
};



// WEBPACK FOOTER //
// ./src/config/apilookupkeys.tsx